import request from "@/router/axios";

/**
 * 文件流返回
 * @param url 接口地址
 */
export const exportBlob = (url) => {
  return request({
    url: url,
    method: 'get',
    responseType: 'blob'
  })
}

export const exportBlobParams = (url,params) => {
  return request({
    url: url,
    method: 'get',
    responseType: 'blob',
    params: {
      ...params
    }
  })
}

// 根据合同号获取详情
export const getDetailContract = (params) => {
  return request({
    url: 'api/blade-salecontract/saleContract/getDetail',
    method: 'get',
    params: {
      ...params
    }
  })
}


// 查询功能字段配置
export const getConfigInformation = (data) => {
  return request({
    url: '/api/blade-table-config/table-config/get-config-information',
    method: 'post',
    data
  })
}